export const roomTypeModel = {
    code: "",
    name: "",
    url: "",
    customName: ""
};
